/* eslint-disable array-callback-return*/

/**
 *
 * Pilih DPJP Layanan hanya digunakan pada rawat jalan
 *
 */

import { InputOptionMaster } from "App/Component/ui";
import React, { useState, useEffect } from "react";
import { getDataBridge } from "App/Component/layout/Manajemen/Dokter/utils";
import { Grid } from "@material-ui/core";
import { isNull } from "App/utils/helpers";
import { TUJUAN_KUNJUNGAN_NORMAL } from "../constants";

export const PilihDPJPLayanan = ({ formData, setFormData, type }) => {
  const [rows, setRows] = useState([]);

  const setNewData = async () => {
    const response = await getDataBridge();
    const _temp = [];
    if (response.state) {
      response.data.map((item) => {
        _temp.push({
          value: item.kodedokter,
          label: item.namadokter,
        });
      });

      setRows(_temp);
    } else {
      setRows([]);
    }
  };

  useEffect(() => {
    setNewData();
  }, []);

  if (type === "RJ" && formData.tujuan_kunjungan !== TUJUAN_KUNJUNGAN_NORMAL) {
    return (
      <Grid item sm={4}>
        <InputOptionMaster
          name='dpjp_layanan_kode'
          label='DPJP LAYANAN'
          id='dpjp_layanan_kode'
          withSearch={true}
          needParse={false}
          value={formData.dpjp_layanan_kode}
          labelValue={formData.dpjp_layanan_name}
          onChange={(e) => {
            if (isNull(e)) {
              setFormData({
                ...formData,
                dpjp_layanan_kode: null,
                dpjp_layanan_name: "Pilih DPJP Layanan",
              });
            } else {
              setFormData({
                ...formData,
                dpjp_layanan_kode: e?.value,
                dpjp_layanan_name: e?.label,
              });
            }
          }}
          data={rows}
        />
      </Grid>
    );
  } else {
    return <></>;
  }
};
